import { React, useEffect, useState, useRef } from "react";
import { Modal, Table } from "react-bootstrap";
// import Overlay from 'react-bootstrap/Overlay';
// import Popover from 'react-bootstrap/Popover';
import Card from "react-bootstrap/Card";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { getStock } from "../../../apis/api-methods";
import { useSelector } from "react-redux";
import { ModalLoading } from "./ModalLoading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faCircleXmark,
  faTriangleExclamation,
  faXmark,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import "./ModalStockMedicamento.css";
import { getStockInfor } from "../../../firebase/firebase-functions";
import { getStockInfor_V3 } from "../../../firebase/firebase-functions_v3";

export const ModalStockMedicamento = ({
  showStockMedicamento,
  handleCloseStockMedicamento,
  medicamento,
}) => {
  const [stock, setStock] = useState([]);
  const { sedes } = useSelector((state) => state.sedes);
  const [showModalLoading, setShowModalLoading] = useState(true);
  // const [target, setTarget] = useState(null);
  // const [show, setShow] = useState(false);
  const ref = useRef(null);

  const handleRowClick = (linkMaps) => {
    window.open(linkMaps, "_blank");
  };

  // const handleClickInfo = (event) => {
  //   event.stopPropagation();
  //   setShow(!show);
  //   setTarget(event.target);
  // }

  useEffect(() => {
    // const getStockMedicamento = async () => {
    //   const arrStock = await getStock(medicamento.kinf, medicamento.pres);
    //   const arrStockSedes = arrStock
    //     .filter((stock) => stock.DSUC !== "VENTA ONLINE")
    //     .map((stock) => {
    //       const sede = sedes.find((sede) => sede.sede === stock.DSUC);
    //       return { ...stock, ...sede };
    //     });

    //   setShowModalLoading(false);
    //   setStock(arrStockSedes);
    // };
    const getStockMedicamentoInfor = async () => {
      const codigoInfor = medicamento.kinfln;
      try {
        const response = await getStockInfor_V3(codigoInfor);
        if (response.obtenido === true) {
          setShowModalLoading(false);

          // Combinar datos de stock con las sedes y agregar propiedad petitorio minimo y baja demanda de medicamento
          const arrStockSedes = response.datos.map((stock) => {
            const sede = sedes.find(
              (sede) =>
                sede.idsede !== "13" &&
                sede.idsede.padStart(3, "0") === stock.pharmacy_id
            );

            const { petitorio_minimo, baja_demanda } = medicamento;

            return {
              ...stock,
              ...sede,
              petitorio_minimo,
              baja_demanda,
            };
          });

          // Sedes ya incluidas en el mapeo
          const sedesIncluidas = arrStockSedes.map((item) =>
            item.idsede?.padStart(3, "0")
          );

          // Sedes faltantes
          const sedesFaltantes = sedes.filter(
            (sede) =>
              sede.idsede !== "13" &&
              !sedesIncluidas.includes(sede.idsede.padStart(3, "0"))
          );

          // Unión de ambas listas
          const resultadoFinal = [...arrStockSedes, ...sedesFaltantes];

          // Ordenar según el orden original de `sedes`
          const ordenado = sedes
            .filter((sede) => sede.idsede !== "13") // omitimos la sede 13 como siempre
            .map((sedeOriginal) => {
              return resultadoFinal.find(
                (item) =>
                  item.idsede?.padStart(3, "0") ===
                  sedeOriginal.idsede.padStart(3, "0")
              );
            })
            .filter(Boolean); // eliminamos posibles `undefined`

          setStock(ordenado);
        } else {
          setShowModalLoading(false);
          setStock(sedes.filter((s) => s.idsede !== "13")); // mantener consistencia
        }
      } catch (error) {
        console.log(error);
      }
    };

    // getStockMedicamento();
    getStockMedicamentoInfor();
  }, []);

  if (showModalLoading) {
    return <ModalLoading showModalLoading={showModalLoading} />;
  } else {
    return (
      <Modal
        show={showStockMedicamento}
        onHide={handleCloseStockMedicamento}
        size="lg"
      >
        <Modal.Header className="header-modal">
          <Modal.Title style={{ color: "white", fontSize: "1.2rem" }}>
            {medicamento.nombre_medicamento}
          </Modal.Title>
          <div ref={ref}>
            <FontAwesomeIcon
              icon={faXmark}
              size="xl"
              onClick={handleCloseStockMedicamento}
              className="icon-stock"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          {stock.length > 0 ? (
            <div className="container text-start">
              <div className="row">
                <div className="col-12 alerta" role="alert">
                  <p>
                    <strong>
                    La disponibilidad de stock informada corresponde solo a venta presencial en farmacia.
                    </strong>
                  </p>
                </div>
              </div>
              <div className="row ">
                <div className="col-1">
                  <FontAwesomeIcon
                    icon={faCircleCheck}
                    style={{ color: "#6bab17" }}
                    size="lg"
                  />
                </div>
                <div className="col-3">
                  <p>Disponible</p>
                </div>

                <div className="col-1">
                  <FontAwesomeIcon
                    icon={faTriangleExclamation}
                    style={{ color: "#e58f2f" }}
                    size="lg"
                  />
                </div>
                <div className="col-3">
                  <p>Pocas unidades</p>
                </div>

                <div className="col-1">
                  <FontAwesomeIcon
                    icon={faCircleXmark}
                    style={{ color: "#e60000" }}
                    size="lg"
                  />
                </div>
                <div className="col-3">
                  <p>Agotado</p>
                </div>
              </div>

              <div className="row">
                <div className="col align-self-end">
                  <Table className="table table-hover">
                    <thead className="cont-stock">
                      <tr>
                        <th scope="col" className="titulos">
                          NOMBRE SEDE
                        </th>
                        <th scope="col" className="titulos">
                          DIRECCIÓN
                        </th>
                        <th scope="col"></th>
                      </tr>
                    </thead>

                    {stock.map((stock, index) => (
                      <tbody key={index} className="cont-stock">
                        <tr onClick={() => handleRowClick(stock.linkMaps)}>
                          <td>
                            <strong>{stock.sede}</strong>
                          </td>
                          <td>
                            <div className="row">
                              <div className="col-11">{stock.address}</div>

                              <div className="col-1">
                                <FontAwesomeIcon
                                  icon={faLocationDot}
                                  style={{ color: "#694b99" }}
                                />
                              </div>
                            </div>
                          </td>
                          {stock.petitorio_minimo === true || stock.baja_demanda === true ? ( <td>
                            {stock.quantity >= 1 ? (
                              <OverlayTrigger
                                placement="right-end"
                                overlay={
                                  <Tooltip id="tooltip-id">Disponible</Tooltip>
                                }
                              >
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  style={{ color: "#6bab17" }}
                                  size="lg"
                                />
                              </OverlayTrigger>
                            ) : null}
                            {!stock.quantity || stock.quantity < 1 ? (
                              <OverlayTrigger
                                placement="right-end"
                                overlay={
                                  <Tooltip id="tooltip-id">Agotado</Tooltip>
                                }
                              >
                                <FontAwesomeIcon
                                  icon={faCircleXmark}
                                  style={{ color: "#e60000" }}
                                  size="lg"
                                />
                              </OverlayTrigger>
                            ) : null}
                          </td>):( <td>
                            {stock.quantity > 5 ? (
                              <OverlayTrigger
                                placement="right-end"
                                overlay={
                                  <Tooltip id="tooltip-id">Disponible</Tooltip>
                                }
                              >
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  style={{ color: "#6bab17" }}
                                  size="lg"
                                />
                              </OverlayTrigger>
                            ) : null}
                            {stock.quantity >= 1 && stock.quantity <= 5 ? (
                              <OverlayTrigger
                                placement="right-end"
                                overlay={
                                  <Tooltip id="tooltip-id">
                                    Pocas unidades
                                  </Tooltip>
                                }
                              >
                                <FontAwesomeIcon
                                  icon={faTriangleExclamation}
                                  style={{ color: "#e58f2f" }}
                                  size="lg"
                                />
                              </OverlayTrigger>
                            ) : null}
                            {!stock.quantity || stock.quantity < 1 ? (
                              <OverlayTrigger
                                placement="right-end"
                                overlay={
                                  <Tooltip id="tooltip-id">Agotado</Tooltip>
                                }
                              >
                                <FontAwesomeIcon
                                  icon={faCircleXmark}
                                  style={{ color: "#e60000" }}
                                  size="lg"
                                />
                              </OverlayTrigger>
                            ) : null}
                          </td>)}
                         
                        </tr>
                      </tbody>
                    ))}
                  </Table>
                </div>
              </div>
            </div>
          ) : (
            <div className="container text-start">
              <h5>
                {"Stock no disponible por el momento, favor intente más tarde"}
              </h5>
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  }
};
